import { Component, OnDestroy, OnInit, OnChanges, SimpleChanges, ViewEncapsulation, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { concat, Subscription, Subject } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { ProductApiService } from 'src/app/services/product-api.service';

/**
 * Read-only table that displays vendor price history for a product.
 *
 * The pipeline inside `ngOnInit` subscribes to `listOptions$` (a `{ PRODID, VENID }` Subject) via
 * `switchMap(getProdVendorHistoryById)` so each new ID pair cancels the previous in-flight request.
 * Results are stored in `priceHistory` with `totalRecords` set for PrimeNG pagination.
 *
 * On `prodId` or `vendorId` input change, the component pushes the current pair onto `listOptions$`.
 * An initial push is fired in `ngOnInit` to populate the table with whatever IDs are bound at creation.
 */
@Component({
  selector: 'app-product-price-history',
  templateUrl: './product-price-history.component.html',
  styleUrls: ['./product-price-history.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class ProductPriceHistoryComponent implements OnInit, OnDestroy, OnChanges {
  rows: number = 20;
  totalRecords: number;
  loading: boolean = false;

  /** Price history rows returned by `getProdVendorHistoryById`. */
  priceHistory: any[];

  selectedHistoryRow: any;

  /** The product ID whose vendor price history should be displayed. */
  @Input()
  prodId: number;

  /** The vendor ID to filter history rows by. */
  @Input()
  vendorId: number;

  private _productQuery: Subscription;

  /** Internal Subject carrying `{ PRODID, VENID }` pairs to the pipeline. */
  private listOptions$ = new Subject<{ 'PRODID': number, 'VENID': number}>();

  constructor(
    private prodApi: ProductApiService,
    private messageService: MessageService,
  ) { }

  /** Reacts to `prodId` and `vendorId` changes by pushing the current pair onto `listOptions$`. */
  ngOnChanges(changes: SimpleChanges) {
    //console.log('*** ProductListPaidComponent ngOnChanges: enter');
    //environment.production || console.table(changes);
    for (let propName in changes) {
      let change = changes[propName];

      console.log('*** ProductListPaidComponent ngOnChanges ' + propName + ' (actual): ' + JSON.stringify(change.currentValue));
      //console.log('*** ProductListPaidComponent ngOnChanges ' + propName + ' (was):    ' + JSON.stringify(change.previousValue));

      switch (propName) {
        case 'prodId':
        case 'vendorId':
          this.listOptions$.next({ 'PRODID': this.prodId, 'VENID': this.vendorId });
          break;
      }
    }
  }

  /** Unsubscribes the price-history HTTP subscription to prevent memory leaks. */
  ngOnDestroy(): void {
    console.log('*** ProductListPaidComponent in ngOnDestroy')

    if (this._productQuery) { this._productQuery.unsubscribe(); }
  }

  /** Sets up the `listOptions$` → `switchMap` pipeline and fires an initial load. */
  ngOnInit(): void {
    console.log('*** ProductListPaidComponent in ngOnInit')

    this._productQuery =
      this.listOptions$.pipe(

        switchMap((row: any) => {
          console.log('*** ProductListPaidComponent in listOptions$ switchMap: ' + JSON.stringify(row));
          return this.prodApi.getProdVendorHistoryById(row.PRODID, row.VENID);
        })
      )
        .subscribe((data) => {
          this.totalRecords = data.length;
          this.priceHistory = data;
        });

    let md: Date = new Date();
    this.listOptions$.next({ 'PRODID': this.prodId, 'VENID': this.vendorId });

  }
}
